/* eslint-disable no-console */
import { Flex, Tag, Tooltip, Typography } from 'antd';
import { toASCII as toASCIIPunycode, toUnicode as toUnicodePunycode } from 'punycode/';
import { FC, useMemo } from 'react';
import { Translate } from 'react-bootstrap-icons';

interface Props {
  domainName: string;
  withIcon?: boolean;
}

const toASCII = (data: string) => {
  const hostname = data.startsWith('http') ? new URL(data).hostname : data;

  return data.replace(hostname, toASCIIPunycode(hostname));
};

const toUnicode = (data: string) => {
  const hostname = data.startsWith('http') ? new URL(data).hostname : data;

  return data.replace(hostname, toUnicodePunycode(hostname));
};

const DomainPunycode: FC<Props> & { stringFormat: (data: string) => string } = ({ domainName, withIcon = true }) => {
  try {
    const isPunycode = useMemo(() => domainName.includes('xn--'), [domainName]);

    return (
      <Tooltip title={ withIcon && isPunycode ? toASCII(domainName) : null } overlayInnerStyle={{ width: 'max-content' }}>
        <Flex
          align="center"
          style={
            Object.assign(
              withIcon && isPunycode
                ? {
                  cursor: 'help',
                  marginBottom: 0, color: 'inherit', fontSize: 'inherit', maxWidth: 'inherit', textOverflow: 'inherit', overflow: 'inherit'
                }
                : {},
              {
                fontSize: 'inherit',
                color: 'inherit',
                display: 'inline-flex'
              }
            )
          }
        >
          <Typography.Paragraph
            style={{ marginBottom: 0, color: 'inherit', fontSize: 'inherit', maxWidth: 'inherit', textOverflow: 'inherit', overflow: 'inherit' }}
            ellipsis={{
              rows: 1,
              tooltip: false
            }}
          >
            { toUnicode(domainName) }
          </Typography.Paragraph>

          { withIcon && isPunycode && (
            <>
            &nbsp;
              <Typography.Text type="warning">
                <Translate size={ 18 }/>
              </Typography.Text>
            </>
          ) }
        </Flex>
      </Tooltip>
    );
  } catch (error) {
    if (error instanceof Error) {
      console.log(error?.stack);
      return <Tooltip title={ String(error.message) } overlayInnerStyle={{ width: 'max-content' }}>
        <Tag color="error" style={{ height: 20 }}><Translate size={ 16 }/></Tag>
      </Tooltip>;
    } else {
      return <Tag color="error" style={{ height: 20 }}><Translate size={ 16 }/></Tag>;
    }
  }
};

DomainPunycode.stringFormat = (domainName: string) => {
  try {
    return toUnicode(domainName);
  } catch {
    return '#';
  }
};

export { DomainPunycode };
